import './App.css';
import React from "react";
import {BrowserRouter as Router, Route, Routes, Navigate, useLocation} from "react-router-dom";
import {Helmet, HelmetProvider} from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Livre from "./views/Livre";
import Video from "./views/Video";
import Category from "./views/Category";
import BookDetail from "./components/bookDetails";
import VideoDetail from "./components/videoDetails";
import NotFound from "./views/NotFound";
import ScrollToTop from "./components/ScrollToTop";

// Configuration SEO globale
const seoConfig = {
    siteName: "Tisradar",
    titleTemplate: "%s | Tisradar - Formation en Télédétection",
    defaultDescription: "Plateforme éducative dédiée à l'apprentissage du traitement d'images radar et LIDAR, avec des ressources en français et malgache.",
    siteUrl: "https://tisradar.hiqaody.me",
    defaultImage: "/logo.svg",
    twitterHandle: "@tisradar",
    language: "fr"
};

function Layout({children}) {
    const location = useLocation();
    const hideHeaderFooter = location.pathname === "/TsyMisy";
    const isHomePage = location.pathname === "/";

    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <html lang={seoConfig.language}/>
                <meta charSet="utf-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <link rel="icon" href={seoConfig.defaultImage}/>
                <meta name="theme-color" content="#000000"/>

                {/* Balises Open Graph par défaut */}
                <meta property="og:site_name" content={seoConfig.siteName}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={seoConfig.siteUrl + location.pathname}/>

                {/* Balises Twitter Card par défaut */}
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:site" content={seoConfig.twitterHandle}/>

                {/* Balises pour les moteurs de recherche */}
                <meta name="robots" content="index, follow"/>
                <link rel="canonical" href={seoConfig.siteUrl + location.pathname}/>
            </Helmet>

            {!hideHeaderFooter && <Header/>}
            <main
                className={`flex-grow ${!hideHeaderFooter ? 'pt-16' : ''} ${
                    isHomePage ? '' : 'mt-8'
                }`}
            >
                {children}
            </main>
            {!hideHeaderFooter && <Footer/>}
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop/>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/livres" element={<Livre/>}/>
                        <Route path="/categories/:encodedCategory" element={<Category/>}/>
                        <Route path="/videos" element={<Video/>}/>
                        <Route path="/livres/:bookId" element={<BookDetail/>}/>
                        <Route path="/videos/:videoId" element={<VideoDetail/>}/>
                        <Route path="/TsyMisy" element={<NotFound/>}/>
                        {/* Redirection vers la page 404 avec le bon statut HTTP */}
                        <Route path="*" element={
                            <>
                                <Helmet>
                                    <title>Page non trouvée | Tisradar</title>
                                    <meta name="robots" content="noindex, follow"/>
                                </Helmet>
                                <Navigate to="/TsyMisy" replace/>
                            </>
                        }/>
                    </Routes>
                </Layout>
            </Router>
        </HelmetProvider>
    );
}

export default App;